export const scriptheroKeys = {
  discounts: ["scripthero", "discounts"],
  pharmacies: ["scripthero", "pharmacies"],
};
